import { Grid } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';

const TradingPlatform = () => {
  const user_profile = useSelector((state) => state.user);
  const [iframeKey, setIframeKey] = useState(0);
  const [iframeLogin, setIframeLogin] = useState(false);

  const iframeRefresh = () => {
    setIframeKey(prev=>prev+=1);
}

  useEffect(()=>{
    if(user_profile.current_account){
      setIframeLogin(user_profile.current_account);
    }
  },[user_profile.current_account])

  useEffect(()=>{
    iframeRefresh();
  },[iframeLogin])

  return (
    <Grid container justifyContent={'center'} alignItems={'center'}>
      <Grid item xs={12} height={'100vh'} paddingLeft={'1rem'} paddingRight={'1rem'}>
        <iframe 
          title="mt5 trading platform" 
          startup_version='mt5' 
          key={iframeKey}
          src={`https://metatraderweb.app/trade?servers=ACGMarkets-Live, ACGMarkets-Demo&startup_mode=open_demo&lang=en&save_password=on&login=${iframeLogin}`}
          allowfullscreen="allowfullscreen" 
          style={{width: '100%', height: '100%', border: 'none'}}>
        </iframe>
      </Grid>
    </Grid>
  )
}

export default TradingPlatform
